import { FieldPath, UseFormReturn } from "react-hook-form";

import { InfoTooltip } from "./InfoTooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { cn } from "@/lib/utils";

export const FormNumberSelect = <T extends Record<string, unknown>>({
  className,
  disabled,
  fieldName,
  form,
  infoTooltip,
  label,
  options,
}: {
  className?: string;
  disabled?: boolean;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  infoTooltip?: string;
  label: string;
  options: { value: number; label: string }[];
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel className="inline-flex items-center gap-1">
              {label}
              {infoTooltip && <InfoTooltip content={infoTooltip} />}
            </FormLabel>
            <Select
              disabled={disabled}
              onValueChange={(value) => {
                field.onChange(Number(value));
              }}
              // TODO: Required for Owner to properly default, make this cleaner
              value={field.value ? (field.value as number).toString() : ""}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="text-slate-700">
                {options.map((option) => (
                  <SelectItem
                    key={option.value}
                    value={option.value.toString()}
                  >
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
